import {BackstopHideSelector} from '../../../common/constant';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';

import {ProfileImage} from '../ProfileImage/ProfileImage';
import {CommentProfileProps} from './CommentProfileProps.interface';

export function CommentProfile({
  isReply,
  profileImgUrl,
  isMyComment,
}: CommentProfileProps) {
  return (
    <div className="flex h-44pxr shrink-0 items-start">
      {isReply && (
        <Icon
          type={IconType.ListReply}
          className="mr-8pxr"
          disableActiveEffect
        />
      )}
      <div
        id={BackstopHideSelector}
        className={twMerge(
          'h-44pxr w-44pxr overflow-hidden rounded-full inner-line-theme-transparent-20 inner-line-rounded-full inner-line-0.5px',
          isMyComment && 'inner-line-static-point-yellow inner-line-2px'
        )}
      >
        {profileImgUrl && <ProfileImage thumbnailUrl={profileImgUrl} />}
        {!profileImgUrl && (
          <StaticImage imageType={StaticImageType.ProfileStatic} />
        )}
      </div>
    </div>
  );
}
